module.exports = __webpack_public_path__ + "html/remove-availability.template.html";